import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const initialState = {
  loyaltyProducts: null,
  canRedeemPickUp: false,
  isLoyaltyEligible: false,
  loyaltyInfo: null,
  isLoyaltyEnrolled: false
};

/// useBoundStore.persist.clearStorage()

export const useLoyaltyStore = create(
  persist(
    (set) => ({
      setLoyaltyProducts: (value) => set(() => ({ loyaltyProducts: value })),
      setCanRedeemPickUp: (value) => set(() => ({ canRedeemPickUp: value })),
      setLoyaltyInfo: (value) => set(() => ({ loyaltyInfo: value })),
      setIsLoyaltyEligible: (value) => set(() => ({ isLoyaltyEligible: value })),
      setIsLoyaltyEnrolled: (value) => set(() => ({ isLoyaltyEnrolled: value })),
      reset: () => {
        set(initialState);
      },
    }),
    {
      name: 'loyalty-info',
      storage: createJSONStorage(() => localStorage),
    },
    {
      partialize: (state) => ({
        
      }),
    }
  )
);

export default useLoyaltyStore;
